
import { SocketIO } from 'utils/web-sockets';

export enum ConnectionsActions {
  SetSocket = '[Connections] Set Socket',
}

export type SetSocket = {
  type: ConnectionsActions.SetSocket;
  payload: { socket: SocketIO };
};

export const setSocket = (socket: SocketIO): SetSocket => {
  return {
    type: ConnectionsActions.SetSocket,
    payload: { socket },
  };
};

export type ConnectionsTypes = SetSocket;
